<template>
  <div class="waterPrice" v-loading="importLoading">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="合同名称:">
          <el-input v-model="form.contractName" size="mini" placeholder="请选输入合同名称" />
        </el-form-item>
        <el-form-item label="合同编号:">
          <el-input v-model="form.contractCode" size="mini" placeholder="请选输入合同编号" />
        </el-form-item>
        <el-form-item label="供应商:">
          <el-input v-model="form.waterwayName" size="mini" placeholder="请选输入供应商" />
        </el-form-item>
        <el-form-item label="起始港:">
          <el-input v-model="form.startPort" size="mini" placeholder="请选输入起始港" />
        </el-form-item>
        <el-form-item label="交车港:">
          <el-input v-model="form.endPort" size="mini" placeholder="请选输入交车港" />
        </el-form-item>
        <el-form-item label="车型:">
          <el-input placeholder="请输入车型" size="mini" v-model="form.customerCarName"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.status" size="mini" filterable placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待生效" value="0"></el-option>
            <el-option label="生效中" value="1"></el-option>
            <el-option label="已失效" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式:">
          <el-select v-model="form.type" filterable size="mini" placeholder="请选择结算方式">
            <el-option label="全部" value=""></el-option>
            <el-option label="合同" value="0"></el-option>
            <el-option label="预结算" value="1"></el-option>
            <el-option label="预估" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入人员:">
          <el-input placeholder="请输入录入人员" size="mini" v-model="form.createByName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
          <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
          <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
          <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div style="display: flex; justify-content: flex-end">
          <span
            class="el-icon-download el-icon--right"
            style="
              cursor: pointer;
              font-size: 16px;
              margin-right: 20px;
              color: rgba(51, 136, 255, 1);
              display: flex;
              align-items: center;
            "
            @click="download"
            >模板下载</span
          >
          <span style="cursor: pointer; margin-right: 20px">
            <el-upload
              ref="upload"
              class="upload-demo"
              style="color: rgba(51, 136, 255, 1)"
              :action="uploadUrl"
              :auto-upload="true"
              :show-file-list="false"
              :data="uploadData"
              :on-success="planOnSuccess"
              :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
          <span
            style="cursor: pointer; font-size: 16px; color: rgba(51, 136, 255, 1)"
            @click="exportData"
            >导出数据</span
          >
        </div>
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B' }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column
            prop="contractName"
            label="合同名称"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            prop="contractCode"
            label="合同编号"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            prop="waterwayName"
            label="供应商"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            prop="startPort"
            label="起始港"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            prop="endPort"
            label="交车港"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            prop="customerCarName"
            label="车型"
            width="120"
            show-overflow-tooltip
            align="center" />
          <el-table-column prop="taxRate" label="税率%" width="70" align="center" />
          <el-table-column prop="contractFixed" label="合同单价" min-width="120" align="center">
            <template slot-scope="scope">
              {{
                scope.row.contractType == 2
                  ? scope.row.contractFixed + '(阶梯)'
                  : scope.row.contractFixed
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="preparePrice"
            label="预结算单价"
            show-overflow-tooltip
            min-width="100"
            align="center">
            <template slot-scope="scope">
              {{
                scope.row.preparePrice
                  ? scope.row.preparePrice != 0
                    ? scope.row.preparePrice
                    : ''
                  : scope.row.isPerfectPrice == 1
                  ? '--'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="estimatePrice" label="预估单价" align="center" />
          <el-table-column
            prop="createTime"
            label="创建时间"
            show-overflow-tooltip
            width="150"
            align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="createByName"
            label="录入人员"
            show-overflow-tooltip
            width="150"
            align="center" />
          <el-table-column
            prop="startDate"
            label="有效起始"
            align="center"
            width="110" >
            <template slot-scope="scope">{{ scope.row.startDate | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="endDate"
            label="结束时间"
            align="center"
            width="110" >
            <template slot-scope="scope">{{ scope.row.endDate | getCreatTime }}</template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="100">
            <template slot-scope="scope">{{ scope.row.status | statusFormat }}</template>
          </el-table-column>
          <el-table-column label="操作" width="380" align="center">
            <template slot-scope="scope">
              <div>
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.id)"
                  >详情
                </el-button>
                <el-button
                  v-if="scope.row.status === 0 || scope.row.status === 1"
                  size="mini"
                  type="primary"
                  @click="changeClick(scope.row.id, scope.row.status)"
                  class="yellow-bg">
                  {{ scope.row.status === 0 ? '修改' : '修改车型' }}
                </el-button>
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="primary"
                  @click="enableClick(scope.row.id)"
                  >启用
                </el-button>
                <el-button
                  v-if="scope.row.status === 1"
                  size="mini"
                  type="danger"
                  @click="stopClick(scope.row.id)"
                  >停用
                </el-button>
<!--                <el-button size="mini" class="yellow-bg" type="danger" @click="recordBtn(scope.row)">补录合同</el-button>-->
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)"
                  >删除
                </el-button>
                <!--                <el-button v-if="scope.row.status== 1"-->
                <!--                           size='mini' type='primary'-->
                <!--                           @click='changePriceOpenDialog(scope.row)'>修改金额-->
                <!--                </el-button>-->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer" style="margin-top: 20px">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="723px" center>
      <div class="detail">
        <div class="baseInfo">
          <el-form :model="detailData" label-position="left">
            <div class="baseInfoTitle">
              <div class="line" />
              <span>基础信息</span>
              <!-- <p>{{detailData.status|statusFormat}}</p> -->
            </div>
            <div class="baseInfoContent">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="供应商:">
                    <span>{{ detailData.waterwayName }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-col :span="24">
                <el-form-item label="线路名称:">
                  <span>{{ detailData.lineName }}</span>
                </el-form-item>
              </el-col>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="合同名称:">
                    <span>{{ detailData.contractName }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="合同编号:">
                    <span>{{ detailData.contractCode }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="起运地:">
                    <span v-if="!detailData.startPortId">{{ detailData.startPosition }}</span>
                    <span v-else>{{ detailData.startPosition }}【{{ detailData.startPort }}】</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="交车地:">
                    <span v-if="!detailData.endPortId">{{ detailData.endPosition }}</span>
                    <span v-else>{{ detailData.startPosition }}【{{ detailData.endPort }}】</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="有效期始:">
                    <span>{{ detailData.startDate }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="结束时间:">
                    <span>{{ detailData.endDate }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="baseInfoTitle">
              <div class="line" />
              <span>价格信息</span>
            </div>
            <div class="baseInfoContent">
              <el-form label-position="left">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="税率:">
                      <span>{{ detailData.taxRate ? detailData.taxRate + '%' : '无' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="合同价:">
                      <span>{{
                        detailData.contractFixed ? detailData.contractFixed + '元' : '无'
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="预结算价:">
                      <span>{{
                        detailData.preparePrice ? detailData.preparePrice + '元' : '无'
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="预估价:">
                      <span>{{
                        detailData.estimatePrice ? detailData.estimatePrice + '元' : '无'
                      }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="baseInfoContentItem" v-if="detailData.contractType == 2">
                  <div>
                    <el-table
                      :data="detailData.priceBasicsLadders"
                      border
                      :header-cell-style="{
                        color: '#3B3B3B',
                        'font-size': '13px',
                        height: '35px',
                        background: '#E8E8E8',
                      }"
                      :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
                      <el-table-column label="序号" align="center" type="index" />
                      <el-table-column prop="startNum" label="起始数量" align="center" />
                      <el-table-column prop="endNum" label="结束数量" align="center" />
                      <el-table-column prop="contractPrice" label="合同价" align="center" />
                    </el-table>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line" />
                <span>补录合同</span>
              </div>
              <div class="operationTable">
                <el-table
                  :data="contractTableList"
                  border
                  :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B', height: '35px' }">
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"></el-table-column>
                  <el-table-column
                    property="codeNumber"
                    label="合同编号"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    property="contractName"
                    label="合同名称"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    property="typeName"
                    label="合同类型"
                    min-width="100"
                    align="center" />
                  <el-table-column
                    prop="supplementaryContract.rate"
                    label="税率"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    prop="supplementaryContract.taxContractPrice"
                    label="含税合同价"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    prop="supplementaryContract.contractPrice"
                    label="不含税合同价"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    property="startDate"
                    label="开始日期"
                    min-width="100"
                    :formatter="getDate"
                    align="center" />
                  <el-table-column
                    property="endDate"
                    label="结束日期"
                    min-width="100"
                    :formatter="getDate"
                    align="center" />
                  <el-table-column width="200px" label="操作" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="danger" size="small" @click="deleteTableClick(scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="baseInfoTitle">
              <div class="line" />
              <span>适配车型</span>
            </div>
            <div class="baseInfoContent">
              <el-table
                :data="detailData.carModelList"
                style="width: 100%"
                border
                :header-cell-style="{
                  color: '#3B3B3B',
                  'font-size': '13px',
                  height: '35px',
                  background: '#E8E8E8',
                }"
                :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }"
                ref="carTableRef">
                <el-table-column
                  type="index"
                  label="序号"
                  width="50"
                  align="center"></el-table-column>
                <el-table-column label="品牌" prop="brandName" align="center" />
                <el-table-column label="型号" prop="modelName" align="center" />
                <el-table-column label="状态" prop="status" align="center">
                  <template slot-scope="scope">{{ scope.row.status | statusFormat }}</template>
                </el-table-column>
              </el-table>
            </div>
            <!-- <div class="baseInfoTitle">
              <div class="line"/>
              <span>线路设置</span>
            </div>
            <div class="baseInfoContent">
              <el-table
                :data="detailData.priceLineBasics"
                style="width: 100%"
                border
                :header-cell-style="{color:'#3B3B3B','font-size':'13px',height:'35px',background:'#E8E8E8'}"
                :cell-style="{'color':'#7F7F7F','font-size':'13px'}"
                tooltip-effect="dark">
                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                <el-table-column label="车型" prop="customerCarName" show-overflow-tooltip  width="150" align="center" />
                <el-table-column label="税率%" prop="taxRate" align="center" />
                <el-table-column label="合同价格" prop="contractFixed" align="center" />
                <el-table-column label="预结算价格" prop="preparePrice" align="center"/>
                <el-table-column label="预结算方式" prop="prepareType" align="center">
                  <template slot-scope="scope">{{scope.row.prepareType|prepareTypeFormat}}</template>
                </el-table-column>
                <el-table-column label="预估价格" prop="estimatePrice" align="center" />
              </el-table>
            </div> -->
            <div class="operation">
              <div class="operationTitle">
                <div class="line" />
                <span>操作信息</span>
              </div>
              <div class="operationTable">
                <el-table
                  :data="detailData.operateRecordList"
                  border
                  :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B', height: '35px' }">
                  <el-table-column
                    prop="createTime"
                    label="操作时间"
                    align="center"
                    width="160px" />
                  <el-table-column prop="operateType" label="操作类型" align="center" />
                  <el-table-column prop="operationName" label="操作人" align="center" />
                  <el-table-column prop="remark" label="备注" align="center" />
                </el-table>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog title="修改合同" :visible.sync="modifyflag"  width='623px' center>
      <list-modify @modifyclose="modifyshow"></list-modify>
    </el-dialog> -->
    <el-dialog
      :title="dataD.showNumber === 1 ? '添加水路价格' : '修改水路价格'"
      :visible.sync="addflag"
      width="800px"
      center
      @close="dialogClose">
      <waterAdd
        @addclose="addshow"
        :addType="addType"
        :editType="editType"
        :dataD="dataD"
        ref="waterAdd"></waterAdd>
    </el-dialog>

    <!-- 完善价格 -->
    <el-dialog
      title="完善价格"
      :visible.sync="priceSetVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px">
      <div style="padding: 20px">
        <div-border label="价格设置">
          <el-form :model="completeDate" label-width="100px">
            <el-form-item label="结算方式：" style="margin-top: 15px" v-if="completeDate.isWay1">
              <span style="display: inline-block; width: 300px">
                <el-radio-group v-model="completeDate.type" @change="typeChange">
                  <el-radio v-if="completeDate.isWay3" :label="0">未设置</el-radio>
                  <el-radio v-if="completeDate.isWay2 || completeDate.isWay3" :label="1"
                    >合同价格</el-radio
                  >
                  <el-radio v-if="completeDate.isWay3" :label="2">预结算价格</el-radio>
                </el-radio-group>
              </span>
              <span
                style="
                  display: inline-block;
                  width: calc(100% - 320px);
                  text-align: right;
                  padding-right: 15px;
                ">
                <el-input
                  size="small"
                  v-if="completeDate.type == 2"
                  v-model="completeDate.price"
                  placeholder="请输入价格" />
              </span>
            </el-form-item>
            <el-form-item label="结算单价：" v-if="completeDate.type == 1">
              <el-radio-group
                v-model="completeDate.conType"
                style="display: inline-block; width: 220px">
                <el-radio :label="0">固定价格</el-radio>
                <el-radio :label="1">阶梯价格</el-radio>
              </el-radio-group>
              <el-input
                v-if="completeDate.conType == 0"
                size="small"
                v-model="completeDate.price"
                placeholder="请输入价格"
                style="width: calc(100% - 400px); margin-right: 10px" />
              <span v-if="completeDate.conType == 1" class="price-set" @click="ladderShow"
                >设置</span
              >
            </el-form-item>
            <el-form-item
              label="预估价："
              v-if="completeDate.isEst"
              style="width: calc(100% - 250px); display: inline-block"
              :style="!completeDate.isWay1 ? 'margin-top:15px;' : ''">
              <el-input size="small" v-model="completeDate.estimate" placeholder="请输入预估价" />
            </el-form-item>
            <el-form-item
              label-width="0px"
              style="width: 250px; text-align: right; display: inline-block"
              :style="!completeDate.isEst ? 'width:100%;' : ''">
              <el-button
                size="small"
                class="searchBtn"
                :loading="completeLoad"
                @click="priceSetConfirm"
                >确定
              </el-button>
              <el-button size="small" class="resetBtn" @click="priceSetClose">取消</el-button>
            </el-form-item>
          </el-form>
        </div-border>
        <div-border
          :is-need="true"
          v-if="completeDate.isWay1 && completeDate.type != 0"
          label="选择合同"
          style="padding: 29px 20px">
          <div class="nav">
            <div class="navContainer">
              <p>合同名称：</p>
              <el-input
                v-model="condition.contractName"
                size="mini"
                style="width: 150px"
                placeholder="请输入合同名称" />
            </div>
            <div class="navContainer">
              <p>合同编号：</p>
              <el-input
                v-model="condition.codeNumber"
                size="mini"
                style="width: 150px"
                placeholder="请输入合同编号" />
            </div>
            <div class="navContainer">
              <p>签约单位：</p>
              <el-input
                v-model="condition.companyName"
                size="mini"
                style="width: 150px"
                placeholder="请输入签约单位" />
            </div>
            <div class="navBtn">
              <el-button size="small" class="searchBtn" @click="_contractPageList">查询</el-button>
              <el-button size="small" class="resetBtn" @click="resetComplete">重置</el-button>
            </div>
          </div>
          <el-table
            :data="contractData"
            highlight-current-row
            border
            ref="contractTable"
            @current-change="contractChange"
            v-loading="contractLoad"
            :header-cell-style="{
              color: '#3B3B3B',
              'font-weight': '700',
              padding: '0px',
              'font-size': '13px',
              height: '35px',
              background: '#E8E8E8',
            }"
            :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
            <el-table-column type="index" width="50" />
            <el-table-column
              property="codeNumber"
              label="合同编号"
              min-width="150"
              align="center" />
            <el-table-column
              property="contractName"
              label="合同名称"
              min-width="150"
              align="center" />
            <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
            <el-table-column
              property="companyName"
              label="签约单位"
              min-width="150"
              align="center" />
            <el-table-column
              property="startDate"
              label="开始日期"
              min-width="100"
              :formatter="getDate"
              align="center" />
            <el-table-column
              property="endDate"
              label="结束日期"
              min-width="100"
              :formatter="getDate"
              align="center" />
          </el-table>
          <div style="margin-top: 20px">
            <el-pagination
              background
              :page-sizes="[10, 20, 30, 40]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="conditionTotal"
              @size-change="completeSizeChange"
              @current-change="completeCurrentChange"
              :current-page.sync="condition.page"
              :page-size="condition.rows" />
          </div>
        </div-border>
      </div>
    </el-dialog>
    <!-- 阶梯 -->
    <el-dialog
      title="新增水路价格"
      :visible.sync="dialogShow"
      width="723px"
      @close="waterPriceAddClose"
      center
      :append-to-body="true"
      :close-on-click-modal="false">
      <div style="width: 100%; padding: 30px" class="water" v-if="dialogShow">
        <div-border label="价格设置" style="padding: 20px">
          <el-form :model="waterPriceData" ref="addForm" class="demo-ruleForm" :rules="waterRules">
            <el-table
              :data="waterPriceData.DataTable"
              style="width: 100%"
              border
              :header-cell-style="{
                color: '#3B3B3B',
                'font-size': '13px',
                height: '35px',
                background: '#E8E8E8',
              }"
              :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
              <el-table-column
                type="index"
                width="50"
                align="center"
                label="序号"></el-table-column>
              <el-table-column label="起始数量" prop="startNum" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0px"
                    :prop="`DataTable[${scope.$index}].startNum`"
                    :rules="waterRules.startNum">
                    <el-input
                      size="mini"
                      v-model="scope.row.startNum"
                      placeholder="请输入起始数量"
                      disabled>
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="结束数量" prop="endNum" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0px"
                    :prop="`DataTable[${scope.$index}].endNum`"
                    :rules="waterRules.endNum">
                    <el-input
                      size="mini"
                      :disabled="scope.$index + 1 != waterPriceData.DataTable.length"
                      v-model="scope.row.endNum"
                      placeholder="请输入结束数量"
                      @change="waterPriceDataEndNumberChange(scope.$index, scope.row.endNum)">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="合同价" prop="contractPrice" align="center">
                <template slot-scope="scope">
                  <el-form-item
                    label-width="0px"
                    :prop="`DataTable[${scope.$index}].contractPrice`"
                    :rules="waterRules.contractPrice">
                    <el-input
                      size="mini"
                      v-model="scope.row.contractPrice"
                      placeholder="请输入合同价">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="50">
                <i
                  class="el-icon-error"
                  style="font-size: 20px; cursor: pointer"
                  slot-scope="scope"
                  @click="waterPriceDeleteTable(scope.$index)"
                  v-if="
                    waterPriceData.DataTable.length > 1 &&
                    scope.$index + 1 == waterPriceData.DataTable.length
                  "></i>
                <span v-else>--</span>
              </el-table-column>
              <div slot="append" style="padding: 9px">
                <el-button
                  size="medium"
                  type="warning"
                  icon="el-icon-plus"
                  circle
                  style="padding: 4px"
                  @click="waterPriceAdd" />
                <span style="margin: 10px">添加</span>
              </div>
            </el-table>
          </el-form>
        </div-border>
        <div style="display: flex; flex-direction: row; justify-content: center">
          <el-button size="mini" class="searchBtn" @click="waterPriceConfirm">确认</el-button>
          <el-button size="mini" class="resetBtn" @click="waterPriceAddClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  补录合同  -->
    <el-dialog
      title="补录合同"
      :visible.sync="contractVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px"
      @close="cancel">
      <div-border label="价格设置">
        <div class="nav" style="margin-top: 10px">
          <div class="navContainer" style="width: 300px">
            <p style="width: 100px">不含税金额：</p>
            <el-input
              v-model="condition.price"
              size="mini"
              style="width: 150px"
              placeholder="请输入不含税金额" />
          </div>
          <div class="navContainer">
            <p>含税金额：</p>
            <el-input
              v-model="condition.taxPrice"
              size="mini"
              style="width: 150px"
              placeholder="请输入含税金额" />
          </div>
          <div class="navBtn">
            <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
            <el-button size="small" class="resetBtn" @click="cancel">取消</el-button>
          </div>
        </div>
      </div-border>
      <div-border label="选择合同">
        <el-table
          :data="contractTableData"
          highlight-current-row
          border
          ref="contractTable"
          @current-change="contractChange"
          v-loading="contractLoad"
          style="margin-top: 10px"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-weight': '700',
            padding: '0px',
            'font-size': '13px',
            height: '35px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
          <el-table-column type="index" width="50" />
          <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
          <el-table-column
            property="contractName"
            label="合同名称"
            min-width="150"
            align="center" />
          <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
          <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
          <el-table-column
            property="startDate"
            label="开始日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
          <el-table-column
            property="endDate"
            label="结束日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
        </el-table>
        <div style="margin-top: 20px">
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="contractTotal"
            @size-change="addContractSizeChange"
            @current-change="addContractCurrentChange"
            :current-page.sync="page"
            :page-size="row" />
        </div>
      </div-border>
    </el-dialog>
    <changePrice @success="searchBtn" ref="changePriceRef" />
  </div>
</template>

<script>
  import waterAdd from '@/views/financial/price/incomeLinePrice/components/waterAdd';
  import {
    waterwayLinePageList,
    waterwayDetail,
    waterEnableStop,
    contractPageList,
    completeWaterPrice,
    waterDelete,
    getContractInfo,
    getContractPageList,
    addContract,
    deleteContractInfo,
  } from '@/service/financial';
  import divBorder from '@/components/divBorder';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import changePrice from '@/components/changePrice';

  export default {
    components: {
      waterAdd,
      divBorder,
      changePrice,
    },
    data() {
      return {
        importLoading: false,
        form: {
          contractName: '', // 合同名称
          contractCode: '', // 合同编号
          waterwayName: '', // 供应商
          startPort: '', // 起始港
          endPort: '', // 交车港
          createByName: '',
          customerCarName: '',
          status: '',
          type: '',
          page: 1,
          rows: 10,
        },
        total: 0,
        contractTotal: 0,
        tableLoad: false,
        TableDatas: [
          // {fullName:'民生整车物流信息分公司1',referred:'民生物流1',tell:'02358600000',area:'重庆市-渝北区',address:'重庆市渝北区xxx',name:'张三',nameTell:'17700000000',state:'启用中'},
        ],
        activeName: 'default',
        detailDialogVisible: false,
        lineOption: [],
        waterSuppler: [],
        detailData: {
          state: '待生效',
          number: '1234567',
          referred: '民生物流1',
          type: '商务合同',
          company: '重庆什么dfsdfsdfsdfsdfdfsdfsdf公司',
          price: '12345666',
          tell: '02358600000',
          mail: '3150000000@qq.com',
          area: '重庆市-渝北区',
          address: '重庆市渝北区xxx',
          name: '张晓辉',
          nameTell: '17700000000',
          time: '2021-8-31 15:25:53',
          createMan: '李忘生',
          basicsData: [],
        },
        contractTableList: [],
        operationData: [
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '启用',
            account: '王三文',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '禁用',
            account: '张三丰',
            remark: '',
          },
          {
            operateTime: '2021-8-31 15:49:58',
            operateType: '添加',
            account: '赵兮雪',
            remark: '',
          },
        ],
        addflag: false,
        //1 为添加，2为修改
        dataD: {
          showNumber: 1,
          user_id: '',
          data: {},
        },
        addType: false,
        reviseData: {}, // 修改默认数据

        //修改金额
        dialogDetailVisible: false,
        dialogNames: '',
        changePriceId: '',

        // 完善价格
        priceSetVisible: false, // 弹窗显隐
        completeDate: {
          id: '',
          type: 0, // 结算方式
          price: '', // 价格
          estimate: '', // 预估价
        },
        contractVisible: false,
        contractTableData: [],
        completeLoad: false,
        // 合同查询条件
        condition: {
          price: '',
          taxPrice: '',
          priceInfoId: '',
          rate: '',
        },
        page: 1,
        row: 10,
        conditionTotal: 0,
        contractLoad: false,
        contractData: [],
        selectContract: {
          id: '',
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        // 阶梯
        dialogShow: false,
        waterPriceData: {
          DataTable: [
            {
              startNum: '0',
              endNum: '',
              contractPrice: '',
            },
          ],
        },
        waterRules: {
          startNum: {
            required: true,
            message: '请输入起始数量',
            trigger: 'blur',
          },
          // endNum:{ required: true, message: '请输入结束数量', trigger: 'blur' },
          contractPrice: {
            required: true,
            message: '请输入合同价格',
            trigger: 'blur',
          },
        },

        // 批量导入 -- 数据
        uploadUrl: '', //导入地址
        uploadData: { mFile: '' }, // 导入数据
        editType: 0,
        checkTableData: [],
      };
    },
    filters: {
      transportTypeFormat(value) {
        switch (value) {
          case 1:
            return '公路';
          case 2:
            return '水路';
        }
      },
      statusFormat(value) {
        switch (value) {
          case 0:
            return '待生效';
          case 1:
            return '生效中';
          case 2:
            return '已失效';
        }
      },
      prepareTypeFormat(value) {
        switch (value) {
          case 1:
            return '固定';
          case 2:
            return '比例';
        }
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    created() {
      this.uploadUrl = getImportUrl('/price/waterwayLine/batchWaterLinePrice');
    },
    mounted() {},
    methods: {
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0)
          return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认要启用当前选中线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            const res = await waterEnableStop({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 分页查询
      async _lineConsignorLineList() {
        this.tableLoad = true;
        let res = await waterwayLinePageList({
          ...this.form,
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 改变每页数据量大小
      contractSizeChange(row) {
        this.form.rows = row;
        this.$refs.tableRef.clearSelection();
        this.checkTableData = [];
        this._lineConsignorLineList();
      },
      // 换页
      contractCurrentChange(page) {
        this.form.page = page;
        this._lineConsignorLineList();
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 查询
      searchBtn() {
        this.form.page = 1;
        this._lineConsignorLineList();
      },
      // 重置
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;
      },
      // 新增 —— 打开弹窗
      addBtn() {
        this.editType = 0;
        this.dataD.showNumber = 1;
        this.addType = false;
        this.addflag = true;
        this.$nextTick(() => {
          this.$refs.waterAdd._publicSelectLine(2);
          this.$refs.waterAdd._customerInfoSelectList();
          this.$refs.waterAdd._getCarSerieList();
        });
      },
      // 对象数组排序
      compare(property) {
        return (a, b) => {
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        };
      },
      // 详情
      async detailClick(id) {
        this.detailDialogVisible = true;
        const res = await waterwayDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        const res1 = await getContractInfo(id);
        if (res1.status !== 0) return this.$message.error(res1.message);
        this.contractTableList = res1.data;
        // if(this.detailData.priceBasicsLadders&&this.detailData.priceBasicsLadders.length>0) {
        //   this.detailData.priceBasicsLadders.sort(this.compare('sort'));
        // }
        // 运输线路
        // let res1 = await publicSelectLine({ type: 2 });
        // if (res1.status !== 0) return this.$message.error(res1.message);
        // if(res1.data.length>0) {
        //   res1.data.forEach(item => {
        //     if(item.id == this.detailData.lineId) {
        //       this.detailData.startPosition = item.start_address_name;
        //       this.detailData.endPosition = item.end_address_name;
        //       this.detailData.startPortId = item.departure_port_id;
        //       this.detailData.startPort = item.departure_port;
        //       this.detailData.endPortId = item.arrive_port_id;
        //       this.detailData.endPort = item.arrive_port;
        //     }
        //   });
        // }
      },
      // 修改 —— 打开弹窗
      async changeClick(id, type) {
        this.editType = type;
        const res = await waterwayDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.dataD.data = res.data;
        this.dataD.showNumber = 2;
        this.dataD.user_id = id;
        this.addflag = true;
        this.$nextTick(() => {
          this.$refs.waterAdd._customerInfoSelectList();
          this.$refs.waterAdd._getCarSerieList();
          this.$refs.waterAdd.getRevise();
        });
        this.addType = false;
      },
      // 启用
      enableClick(id) {
        this.$confirm('确认要启用线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: id,
              status: 1,
            };
            const res = await waterEnableStop(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      // 停用
      stopClick(id) {
        this.$confirm('确认要停用线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: id,
              status: 2,
            };
            const res = await waterEnableStop(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStops() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认要停用线路价格吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              const ids = this.checkTableData.map(item => item.id).join(',');
              const res = await waterEnableStop({
                id: ids,
                status: 2,
              });
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this._lineConsignorLineList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择要停用的线路价格！',
            type: 'warning',
          });
        }
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认要删除线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await waterDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认要删除线路价格吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData['id'] + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              let res = await waterDelete(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this._lineConsignorLineList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      //修改金额-打开对话框
      changePriceOpenDialog(row) {
        this.$refs.changePriceRef.dialogOpen(row.id, 5);
      },
      /**
       * 完善价格
       */
      // 完善价格 —— 结算方式改变
      typeChange(type) {
        if (type == 1) {
          this.completeDate.conType = 0;
        } else {
          this.completeDate.conType = '';
        }
      },
      // 完善价格 —— 打开弹窗
      complete(row) {
        this.condition.page = 1;
        this.completeDate = {
          id: row.id,
          isWay1: row.contractType == 1 || row.contractType == 2 ? false : true,
          isWay2: row.contractType == 0 ? true : false,
          isWay3: row.contractType == -1 ? true : false,
          isEst: row.estimatePrice ? false : true,
          waterwayId: row.waterwayId,
          type: 0,
          conType: '',
          price: '',
          estimate: row.estimatePrice || '',
          priceBasicsLadders: row.priceBasicsLadders || [],
        };
        if (row.contractId) {
          this.selectContract = { id: row.contractId };
        } else {
          this.selectContract = '';
        }
        this.priceSetVisible = true;
        this._contractPageList();
      },
      // 完善价格 —— 合同分页查询
      async _contractPageList() {
        let obj = {
          ...this.condition,
          id: this.completeDate.waterwayId,
        };
        this.contractLoad = true;
        let res = await contractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.contractData = res.data;
        this.total = res.data.total || 0;
        if (this.selectContract.id && this.contractData.length > 0) {
          this.contractData.forEach(item => {
            if (item.id == this.selectContract.id) {
              if (this.$refs.contractTable) this.$refs.contractTable.setCurrentRow(item);
            }
          });
        }
      },
      // 完善价格 —— 重置
      resetComplete() {
        for (let key in this.condition) {
          if (key == 'page' || key == 'rows') continue;
          this.condition[key] = '';
        }
      },
      completeSizeChange(rows) {
        this.condition.rows = rows;
        this._contractPageList();
      },
      completeCurrentChange(page) {
        this.condition.page = page;
        this._contractPageList();
      },
      // 补录合同
      recordBtn(row) {
        this.condition.id = row.id;
        this.companyId = row.waterwayId;
        (this.condition.rate = row.taxRate), (this.contractPrice = row.contractPrice);
        this.preparePrice = row.preparePrice;
        this.startDate = row.startDate;
        this.endDate = row.endDate;
        this.selectContract = '';
        this.getContractPage();
      },
      //查询
      async getContractPage() {
        let obj = {
          id: this.condition.id,
          companyId: this.companyId,
          rate: this.condition.rate,
          contractPrice: this.contractPrice ? this.contractPrice : '',
          preparePrice: this.preparePrice ? this.preparePrice : '',
          page: this.page,
          row: this.row,
        };
        this.contractLoad = true;
        let res = await getContractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          this.contractVisible = false;
        } else {
          this.contractVisible = true;
          this.contractTableData = res.data.records;
          this.contractTotal = res.data.total;
        }
      },
      async contractConfirm() {
        if (!this.condition.price || this.condition.price === '') {
          return this.$message.warning('请输入不含税金额！');
        }
        if (!this.condition.taxPrice || this.condition.taxPrice === '') {
          return this.$message.warning('请输入含税金额！');
        }
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        let obj = {
          type: 4,
          rate: this.condition.rate,
          taxPrice: this.condition.taxPrice,
          price: this.condition.price,
          priceInfoId: this.condition.id,
          contractId: this.selectContract.id,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        const res = await addContract(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.contractVisible = false;
        this.searchBtn();
      },
      cancel() {
        this.condition.price = '';
        this.condition.taxPrice = '';
        this.contractVisible = false;
      },
      //详情-补录合同-删除
      deleteTableClick(row) {
        this.$confirm('确认删除当前合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          let obj = {
            priceInfoId: row.supplementaryContract.priceInfoId,
            contractId: row.supplementaryContract.contractId,
            type: 4,
          };
          const res = await deleteContractInfo(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.detailDialogVisible = false;
        });
      },
      // 补录合同 —— 选中合同
      contractChange(val) {
        this.selectContract = val;
      },
      addContractSizeChange(rows) {
        this.row = rows;
        this.getContractPage();
      },
      addContractCurrentChange(page) {
        this.page = page;
        this.getContractPage();
      },
      // 完善价格 —— 确认
      async priceSetConfirm() {
        console.log(this.completeDate.type == 2);
        if (
          ((this.completeDate.type == 1 && this.completeDate.conType == 0) ||
            this.completeDate.type == 2) &&
          (!this.completeDate.price || this.completeDate.price == '')
        ) {
          return this.$message.warning('请输入价格！');
        }
        // 阶梯价  结算方式
        if (this.completeDate.type == 1 && this.completeDate.conType == 1) {
          if (
            this.completeDate.priceBasicsLadders &&
            this.completeDate.priceBasicsLadders.length <= 0
          ) {
            return this.$message.warning('请设置阶梯价格！');
          }
        }
        if (
          this.completeDate.type == 1 &&
          (!this.selectContract.id || this.selectContract.id == '')
        ) {
          return this.$message.warning('请选择合同！');
        }
        let obj = {
          id: this.completeDate.id,
          contractType:
            this.completeDate.type == 1 && this.completeDate.conType == 1
              ? 2
              : this.completeDate.type == 2
              ? 0
              : this.completeDate.type == 1 && this.completeDate.conType == 0
              ? 1
              : -1,
          contractFixed: this.completeDate.type == 1 ? this.completeDate.price : '',
          preparePrice: this.completeDate.type == 2 ? this.completeDate.price : '',
          contractId: this.completeDate.type == 1 ? this.selectContract.id : '',
          estimatePrice: this.completeDate.isEst ? this.completeDate.estimate : '',
          priceBasicsLadders:
            this.completeDate.type == 1 && this.completeDate.conType == 1
              ? this.completeDate.priceBasicsLadders
              : [],
        };
        this.completeLoad = true;
        let res = await completeWaterPrice(obj);
        this.completeLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.waterPriceData.DataTable = [];
        this._lineConsignorLineList();
        this.priceSetVisible = false;
      },
      // 完善价格 —— 取消
      priceSetClose() {
        this.waterPriceData.DataTable = [];
        this.priceSetVisible = false;
      },

      // 阶梯
      ladderShow() {
        this.dialogShow = true;
      },
      // 阶梯 —— 添加
      waterPriceAdd() {
        if (this.waterPriceData.DataTable.length > 0) {
          if (
            this.waterPriceData.DataTable[this.waterPriceData.DataTable.length - 1].endNum == ''
          ) {
            return this.$message.warning('请输入结束数量');
          }
          let len = parseInt(
            this.waterPriceData.DataTable[this.waterPriceData.DataTable.length - 1].endNum,
          );
          this.waterPriceData.DataTable.push({
            startNum: len + 1,
            endNum: '',
            contractPrice: '',
          });
        } else {
          this.waterPriceData.DataTable = [
            {
              startNum: '0',
              endNum: '',
              contractPrice: '',
            },
          ];
        }
      },
      // 阶梯 —— 删除
      waterPriceDeleteTable(index) {
        this.waterPriceData.DataTable.splice(index, 1);
      },
      // 阶梯 —— 结束数量
      waterPriceDataEndNumberChange(index, value) {
        if (!value || value == '') return false;
        if (Number(value) < Number(this.waterPriceData.DataTable[index].startNum)) {
          this.$message.warning('结束数量必须大于起始数量');
          this.waterPriceData.DataTable[index].endNum = '';
        }
      },
      // 阶梯 —— 确认
      waterPriceConfirm() {
        this.$refs.addForm.validate(async valid => {
          if (valid) {
            this.completeDate.priceBasicsLadders = [...this.waterPriceData.DataTable];
            this.dialogShow = false;
          }
        });
      },
      // 阶梯 —— 取消
      waterPriceAddClose() {
        this.dialogShow = false;
        // this.waterPriceData.DataTable = [];
      },

      // 新增/修改 —— 关闭弹窗
      addshow(val) {
        this.addType = false;
        this.addflag = val;
        this._lineConsignorLineList();
      },
      // 新增/修改 —— 取消
      dialogClose() {
        this.$refs.waterAdd.dialogClose();
      },

      /**
       * 批量导入
       */
      //模板下载
      download() {
        window.location.href = '/file/水路供应商运费线路价格导入模板.xlsx';
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._lineConsignorLineList();
          },
        });
      },
      beforeUpload(file) {
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        const { contractName, contractCode, waterwayName, startPort, endPort, status,type,customerCarName } = this.form;
        // window.location.href = `${baseUrl}/platform/price/waterwayLine/waterWayLinePriceExport?access_token=${token}&waterwayName=${waterwayName}&contractName=${contractName}&contractCode=${contractCode}&customerCarName=${customerCarName}&startPort=${startPort}&endPort=${endPort}&type=${type}`;
        window.exportExcelGet('/platform/price/waterwayLine/waterWayLinePriceExport', `waterwayName=${waterwayName}&contractName=${contractName}&contractCode=${contractCode}&customerCarName=${customerCarName}&startPort=${startPort}&endPort=${endPort}&type=${type}`)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .waterPrice {
    /*width:100%;*/
    padding: 0 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        .el-form-item {
          margin-bottom: 5px;
        }

        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        .el-table td,
        .el-table th {
          padding: 0;
        }

        .el-table td .cell {
          font-weight: 400;
        }

        .cell {
          font-size: 10px;
          padding: 0;
          font-weight: 900;
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-form-item {
            margin-bottom: 2px;
            font-weight: 700;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          /*margin-top: 10px;*/
          padding: 20px;
        }
      }
    }
  }

  ::v-deep {
    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px !important;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

    .el-dialog__wrapper {
      top: -52px;
    }
  }

  .set-up {
    color: #3187ff;
    position: absolute;
    padding-right: 10px;
    height: 24px;
    line-height: 24px;
    right: 10px;
    top: calc(50% - 12px);
    text-decoration: underline;
    cursor: pointer;
  }

  .navBtn {
    display: inline-block;
    width: calc(100% - 690px);
    text-align: right;
    margin-bottom: 10px;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }
  }

  .price-set {
    color: #3187ff;
    text-decoration: underline;
    cursor: pointer;
  }
</style>
